// Common to Main and Distribution App
// Add polyfills and generally all configuration that should be the same in both parts of the app.
//
// We don't appear to be actively doing anything with these imports, so presumably the
// intent is that the actual import command itself is enough to cause the required registration / configuration
//
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "typeface-nunito/index.css";
import "typeface-open-sans/index.css";
import "@js-joda/timezone";
import "@/plugins/validation";
import "@/plugins/portalVue";
import "@/plugins/signaturePad";

import Vue from "vue";
import environment from "@/environment";

const configureCommonImports = () => {
  Vue.config.productionTip = false;
  Vue.config.devtools = true;
  Vue.config.performance = environment.isDevelopment;
};

export { configureCommonImports };
